import { RefreshCw } from "lucide-react";

interface RefreshButtonProps {
  onClick: () => void;
  loading?: boolean;
  label?: string;
  className?: string;
}

export default function RefreshButton({ onClick, loading = false, label = "Refresh", className = "" }: RefreshButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className={`flex items-center gap-1.5 rounded-lg border border-gray-200 px-2.5 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-40 ${className}`}
    >
      <RefreshCw size={13} className={loading ? "animate-spin" : ""} aria-hidden="true" />
      {label}
    </button>
  );
}
